import { Component } from "@angular/core";
import { NbDialogRef } from "@nebular/theme";

@Component({
  template: `
    <nb-card>
      <nb-card-header
        >Are you sure you want to proceed with this action?</nb-card-header
      >
      <nb-card-footer>
        <button nbButton status="danger" (click)="cancel()">Cancel</button>
        <button nbButton status="success" (click)="confirm()">Confirm</button>
      </nb-card-footer>
    </nb-card>
  `,
})
export class CreateDialogComponent {
  constructor(protected dialogRef: NbDialogRef<CreateDialogComponent>) {}

  cancel() {
    this.dialogRef.close(false);
  }

  confirm() {
    this.dialogRef.close(true);
  }
}
